import React from 'react';

import { Section } from '../..';
import { defaultPropTypes } from '../AdditionalData';

const Languages = ({ field, translations }) => (
    <Section.Conditional
        condition={Boolean(field.languageCompetences.length)}
        title={translations.languages}
    >
        {({ renderField }) => (
            <>
                {field.languageCompetences.map(({ competencesLanguageName, languageCompetencyLevelName, languageId, languageCompetenceLevelId }) => renderField(competencesLanguageName, languageCompetencyLevelName, null, `lang__${languageId}_${languageCompetenceLevelId}`))}
            </>
        )}
    </Section.Conditional>
);

Languages.propTypes = defaultPropTypes;

export default Languages;
